var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"s-icon",class:_vm.icon,attrs:{"aria-hidden":"true"},on:{"click":function($event){return _vm.$emit("click", $event)}}},[_c('use',{attrs:{"xlink:href":("#icon-" + _vm.icon)}})])}
var staticRenderFns = []

export { render, staticRenderFns }